import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import swal from 'sweetalert2';
import {AppConfig} from '../../shared/dto/app-config.model';
import {AuthService} from '../../shared/service/auth.service';
import {SessionService} from '../../shared/service/session.service';
import {UserDetailModel} from '../../shared/dto/user-detail.model';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {SysConfigService} from '../../shared/service/sys-config.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input()
  public appConfig: AppConfig;
  public loginForm: FormGroup;
  public userId: number;
  sessionExpire: boolean = false;

  get username() {
    return this.loginForm.get('username');
  }

  get password() {
    return this.loginForm.get('password');
  }

  public formError = '';

  constructor( private authService: AuthService,
               private router: Router,
               private route: ActivatedRoute,
               private sysConfigService: SysConfigService,
               private sessionService: SessionService,
               private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      if (params.get('code') === 'sessionexpire')
        this.sessionExpire = true;
    });
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  ngOnDestroy() {
    console.log('Destroyed');
  }

  login(){
    const login: UserDetailModel = new UserDetailModel(this.loginForm.value.username,this.loginForm.value.password,null,null,null
    ,null,null,null,null,null,null,null,null);

    this.attemptAuth(login);
  }


  attemptAuth(login: UserDetailModel) {
    this.authService.login(login).subscribe(
      (response :UserDetailModel)=> {
        if(response != null){
          console.log('RESPONSE' + response.userroleCode);
          this.sessionService.setUser(response['user']);
          this.sysConfigService.getConfig.emit({
            color: "red",
            user: true,
            header: true,
            footer: true
          });
          //setPermission
          this.tokenStorageService.saveUserObjectToken(response);
          if(response.userroleCode === UserRoleEnum.ADMIN){
            this.router.navigate([`/dashboard/adminDashboard`], { relativeTo: this.route });
          }else{
            this.router.navigate([`/dashboard/dashHome`], { relativeTo: this.route });
          }

        }
        else{
          this.formError = "Invalid Credentials";
          this.loginForm.setErrors({ invalidLogin: true });
        }
      },
      error => {
        if (error.error.status === 500) {
          this.formError = 'Internal server error';
          this.loginForm.setErrors({ serverError: true });
        } else {
          this.formError = 'Invalid Credentials';
          this.loginForm.setErrors({ invalidLogin: true });
        }

        swal.fire('Error', 'Login failed', 'error');
      }
    );
  }

  setRequestId(requestId: number){
    this.userId = requestId;
  }

}
